import { COLOR_PAGES, COLOR_PAGES_PATH, colorPagePath } from "@roof-hawk/core";
import { useState } from "react";

import { ErrorNote } from "../../components/ui";
import { t } from "../../i18n";

/** What somebody would text, built off the page it is read on, so it is
 * right on production, on test and on a laptop. */
const linkFor = (path: string): string => `${window.location.origin}${path}`;

/**
 * The colour options, as links a rep can send on their own.
 *
 * Jonathon, 2026-09-30: "sometimes we want to send all of these color options
 * to customers via links". One row per lineup a proposal can show, plus the
 * page that lists them all. Each opens what the card on a proposal opens
 * (`COLOR_PAGES` in packages/core); nothing here is edited.
 */
export function ColorLinksTool() {
  const [copied, setCopied] = useState<string | null>(null);
  const [problem, setProblem] = useState<string | null>(null);

  async function copy(path: string) {
    try {
      await navigator.clipboard.writeText(linkFor(path));
      setCopied(path);
      window.setTimeout(() => setCopied(null), 2000);
    } catch {
      setProblem(
        t("This browser would not let us copy. Select the link instead."),
      );
    }
  }

  const row = (label: string, path: string) => (
    <div key={path} className="intakelink-row">
      <div className="intakelink-who">{label}</div>
      <code>{linkFor(path)}</code>
      <a className="btn" href={path} target="_blank" rel="noreferrer noopener">
        {t("Open")}
      </a>
      <button
        type="button"
        className="btn"
        aria-label={t("Copy the {label} link", { label })}
        onClick={() => void copy(path)}
      >
        {copied === path ? t("Copied") : t("Copy")}
      </button>
    </div>
  );

  return (
    <div className="intakelinks colorlinks">
      {problem ? <ErrorNote error={problem} /> : null}

      <p className="dim">
        {t(
          "Text or email one of these to a customer. Each opens the same colors the card on a proposal opens, and nobody needs to sign in.",
        )}
      </p>

      {row(t("Every color option"), COLOR_PAGES_PATH)}

      {COLOR_PAGES.map((page) => row(page.label, colorPagePath(page)))}
    </div>
  );
}
